import _ from "lodash";
//
import { FormattedMessage } from "react-intl";
import React from "react";
import Act from "../../../../../store/actions";
import { isEmpty, isEquals } from "../../../../../common/utils";
import {
  getDefaultStartEndDate,
  snaTimePeriodOptions,
  // eslint-disable-next-line import/named
  SNA_BASIC_SETTING,
} from "../../../../../config/config.sna";
import {
  getUserSettings,
  updateUserSettings,
} from "../../../service/settingService";

// 儲存 file tool 設定
export const saveFileToolSetting = (state, dispatch) => {
  // todo:
  // 儲存到 local or firebase
};

// data: {key1:{initial:[], change:[]},key2:{initial:[], change:[]}}
export const isChanged = (data, checkKeys = []) => {
  let _isChanged = false;
  const getSafeVal = (val) => {
    if (typeof val === "number") return String(val);
    if (val === null || val === undefined) return "";
    return val;
  };
  Object.entries(data).forEach(([key, { initial, change }]) => {
    if (Array.isArray(checkKeys) && checkKeys.length > 0) {
      if (!checkKeys.includes(key)) return;
      if (!isEquals(getSafeVal(initial), getSafeVal(change))) {
        _isChanged = true;
      }
    } else if (!isEquals(getSafeVal(initial), getSafeVal(change))) {
      _isChanged = true;
    }
  });
  return _isChanged;
};

// 用來儲存在 realtime/users.uid.settings 的資料格式
// data: {adjust: {nodeColors:{initial:"", change:""}}}
const formatUserSetting4Realtime = (data, rootKey = "") => {
  const newData = {};
  Object.entries(data).forEach(([key, objVal]) => {
    const newKey = rootKey ? `${rootKey}_${key}` : key;
    newData[newKey] = objVal.change;
  });
  return newData;
};

// 儲存 adjust tool 設定
export const saveAdjustToolSetting = (state, dispatch) => {
  //
  const { user, sna } = state;
  const { locale } = user;
  const { adjust } = sna;
  const _isChanged = isChanged(adjust);

  if (_isChanged) {
    dispatch({
      type: Act.SNA_ADJUST_NODE_COLORS_INITIAL,
      payload:
        adjust?.nodeColors?.change || SNA_BASIC_SETTING.adjust_nodeColors,
    });
    dispatch({
      type: Act.SNA_ADJUST_LINK_COLORS_INITIAL,
      payload:
        adjust?.linkColors?.change || SNA_BASIC_SETTING.adjust_linkColors,
    });
    dispatch({
      type: Act.SNA_ADJUST_NODE_PLACEMENT_INITIAL,
      payload:
        adjust?.nodePlaceMode?.change || SNA_BASIC_SETTING.adjust_nodePlaceMode,
    });
    dispatch({
      type: Act.SNA_ADJUST_NODE_SHOW_NODE_COUNT_INITIAL,
      payload:
        adjust?.nodeShowNodeCount?.change ||
        SNA_BASIC_SETTING.adjust_nodeShowNodeCount,
    });
    dispatch({
      type: Act.SNA_ADJUST_NODE_DISPERSION_INITIAL,
      payload:
        adjust?.nodeDispersion?.change ||
        SNA_BASIC_SETTING.adjust_nodeDispersion,
    });
    dispatch({
      type: Act.SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_INITIAL,
      payload:
        adjust?.legendShowNodDataGroup?.change ||
        SNA_BASIC_SETTING.adjust_legendShowNodDataGroup,
    });
    // apply adjust setting
    dispatch({
      type: Act.SNA_APPLY_ADJUST_SETTING,
      payload: true,
    });
  }
  // 儲存到 local or firebase
  updateUserSettings({
    userId: user?.uid,
    data: formatUserSetting4Realtime(adjust, "adjust"),
    onSuccess: () => {
      dispatch({
        type: Act.COMMON_SET_SUCCESS_MESSAGE,
        payload: {
          open: true,
          content: "成功儲存使用者設定",
        },
      });
    },
    onError: (error) => {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: error.message,
        },
      });
    },
  });
};

// 清除 adjust tool 設定
export const clearAdjustToolSetting = (state, dispatch) => {
  const { user, sna } = state;
  const { locale } = user;
  const { adjust } = sna;
  const _isChanged = isChanged(adjust);

  dispatch({
    type: Act.SNA_ADJUST_NODE_COLORS_CHANGE,
    payload: adjust?.nodeColors?.initial || SNA_BASIC_SETTING.adjust_nodeColors,
  });
  dispatch({
    type: Act.SNA_ADJUST_LINK_COLORS_CHANGE,
    payload: adjust?.linkColors?.initial || SNA_BASIC_SETTING.adjust_linkColors,
  });
  dispatch({
    type: Act.SNA_ADJUST_NODE_PLACEMENT_CHANGE,
    payload:
      adjust?.nodePlaceMode?.initial || SNA_BASIC_SETTING.adjust_nodePlaceMode,
  });
  dispatch({
    type: Act.SNA_ADJUST_NODE_SHOW_NODE_COUNT_CHANGE,
    payload:
      adjust?.nodeShowNodeCount?.initial ||
      SNA_BASIC_SETTING.adjust_nodeShowNodeCount,
  });
  dispatch({
    type: Act.SNA_ADJUST_NODE_DISPERSION_CHANGE,
    payload:
      adjust?.nodeDispersion?.initial ||
      SNA_BASIC_SETTING.adjust_nodeDispersion,
  });
  dispatch({
    type: Act.SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_CHANGE,
    payload:
      adjust?.legendShowNodDataGroup?.initial ||
      SNA_BASIC_SETTING.adjust_legendShowNodDataGroup,
  });
};

// 儲存 filter tool 設定
export const saveFilterToolSetting = (state, dispatch) => {
  //
  const { user, sna } = state;
  const { locale } = user;
  const { filter } = sna;
  const { filterEventTypeOn, nodeCountMeetAuthNew } = filter;
  const filterEventTypeChanged =
    filterEventTypeOn.initial !== filterEventTypeOn.change;
  const _isChanged = isChanged(filter);
  const isStartEndDateChange = isChanged(filter, ["startEndDate"]);
  const isTimePeriodChange = isChanged(filter, ["timePeriod"]);
  const isNodeAuthorPreserveChange = isChanged(filter, ["nodeAuthorPreserve"]);
  const isNodeCountMeetAuthNewChange =
    nodeCountMeetAuthNew.initial !== nodeCountMeetAuthNew.change;

  // 時間有變更, 需要重新 fetch data
  if (isStartEndDateChange || isNodeAuthorPreserveChange) {
    dispatch({
      type: Act.SNA_APPLY_FETCH_DATASET,
      payload: true,
    });
  }

  if (_isChanged || filterEventTypeChanged || isNodeCountMeetAuthNewChange) {
    dispatch({
      type: Act.SNA_FILTER_NODE_COUNT_INITIAL,
      payload: filter?.nodeCount?.change || SNA_BASIC_SETTING.filter_nodeCount,
    });
    dispatch({
      type: Act.SNA_FILTER_LINK_COUNT_INITIAL,
      payload: filter?.linkCount?.change || SNA_BASIC_SETTING.filter_linkCount,
    });
    dispatch({
      type: Act.SNA_FILTER_LIMIT_TOTAL_NODES_INITIAL,
      payload:
        filter?.limitTotalNodesCount?.change ||
        SNA_BASIC_SETTING.filter_limitTotalNodesCount,
    });
    dispatch({
      type: Act.SNA_FILTER_TIME_PERIOD_INITIAL,
      payload:
        filter?.timePeriod?.change || SNA_BASIC_SETTING.filter_timePeriod,
    });
    dispatch({
      type: Act.SNA_FILTER_START_END_DATE_INITIAL,
      payload:
        filter?.startEndDate?.change || SNA_BASIC_SETTING.filter_startEndDate,
    });
    dispatch({
      type: Act.SNA_FILTER_NODE_AUTHOR_PRESERVE_INITIAL,
      payload: filter?.nodeAuthorPreserve?.change || [],
    });
    // apply node count meet
    // dispatch({
    //   type: Act.SNA_FILTER_NODE_COUNT_MEET_AUTH_INITIAL,
    //   payload:
    //     filter?.nodeCountMeetAuth?.change ||
    //     SNA_BASIC_SETTING.filter_nodeCountMeetAuth,
    // });
    dispatch({
      type: Act.SNA_FILTER_NODE_COUNT_MEET_AUTH_NEW_INITIAL,
      payload:
        filter?.nodeCountMeetAuthNew?.change ||
        SNA_BASIC_SETTING.filter_nodeCountMeetAuthNew,
    });
    dispatch({
      type: Act.SNA_EVENT_TYPES_FILTER_ON_INITIAL,
      payload: filter?.filterEventTypeOn?.change,
    });
    dispatch({
      type: Act.SNA_EVENT_TYPES_INITIAL,
      payload:
        filter?.eventTypes?.change.filter((el) => el.name !== "未分類") || [],
    });
    // apply filter setting
    dispatch({
      type: Act.SNA_APPLY_FILTER_SETTING,
      payload: true,
    });
    // 儲存到 local or firebase
    updateUserSettings({
      userId: user?.uid,
      data: formatUserSetting4Realtime(filter, "filter"),
      onSuccess: () => {
        dispatch({
          type: Act.COMMON_SET_SUCCESS_MESSAGE,
          payload: {
            open: true,
            content: "成功儲存使用者設定",
          },
        });
      },
      onError: (error) => {
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: error.message,
          },
        });
      },
    });
  }
};

// 清除 filter tool 設定
export const resetFilterToolSetting = (state, dispatch) => {
  const { user, sna } = state;
  const { locale } = user;
  const { filter } = sna;
  const _isChanged = isChanged(filter);

  dispatch({
    type: Act.SNA_FILTER_NODE_COUNT_CHANGE,
    payload: filter?.nodeCount?.initial || SNA_BASIC_SETTING.filter_nodeCount,
  });
  dispatch({
    type: Act.SNA_FILTER_LINK_COUNT_CHANGE,
    payload: filter?.linkCount?.initial || SNA_BASIC_SETTING.filter_linkCount,
  });
  dispatch({
    type: Act.SNA_FILTER_TIME_PERIOD_CHANGE,
    payload: filter?.timePeriod?.initial || SNA_BASIC_SETTING.filter_timePeriod,
  });
  dispatch({
    type: Act.SNA_FILTER_START_END_DATE_CHANGE,
    payload:
      filter?.startEndDate?.initial || SNA_BASIC_SETTING.filter_startEndDate,
  });
  dispatch({
    type: Act.SNA_EVENT_TYPES_FILTER_ON_CHANGE,
    payload: filter?.filterEventTypeOn?.initial,
  });

  const newInitial = filter?.eventTypes?.initial.map((el) => ({
    ...el,
    checked: false,
  }));
  const newChange = filter?.eventTypes?.change.map((el) => ({
    ...el,
    checked: false,
  }));

  dispatch({
    type: Act.SNA_EVENT_TYPES_INITIAL,
    payload: newInitial,
  });

  dispatch({
    type: Act.SNA_EVENT_TYPES_CHANGE,
    payload: newChange,
  });
};

// 儲存 adjust tool 設定
export const saveAnalyticsSetting = (state, dispatch) => {
  //
  const { user, sna } = state;
  const { locale } = user;
  const { analytics } = sna;
  const _isChanged = isChanged(analytics, ["analyticsType"]);

  if (_isChanged) {
    dispatch({
      type: Act.SNA_ANALYTICS_TYPE_INITIAL,
      payload:
        analytics?.analyticsType?.change || SNA_BASIC_SETTING.analytics_type,
    });
  }
};
